export const removeWhiteSpace = (value: any): any | string => {
  if (typeof value === 'string') {
    return value.replace(/^\s+/, '');
  }

  return value;
};
